function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home---Sticky-Table",
  transform: "translate(-205.000000, -310.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(151.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-30",
  transform: "translate(30.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Summary-Copy",
  transform: "translate(0.000000, 108.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Total-Revenue"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-24",
  transform: "translate(24.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#9063CD",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_Video_1559825",
  transform: "translate(15.000000, 17.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-5.75e-07,0.0825702 L-5.75e-07,0.5385702 L-5.75e-07,10.5705588 L-5.75e-07,11.0265816 L0.45999931,11.0265816 L17.9400005,11.0265816 L18.4000005,11.0265816 L18.4000005,10.5705588 L18.4000005,0.5385702 L18.4000005,0.0825702 L17.9400005,0.0825702 L0.45999931,0.0825702 L-5.75e-07,0.0825702 Z M0.91999931,0.9945702 L17.4800005,0.9945702 L17.4800005,10.1145588 L0.91999931,10.1145588 L0.91999931,0.9945702 Z M7.32406181,2.3483202 C7.09772801,2.366127 6.90391851,2.58474936 6.90714607,2.8185702 L6.90714607,8.2905588 C6.91013081,8.613156 7.31111074,8.8499568 7.58281181,8.6895588 L12.1828118,5.9535702 C12.4555527,5.791257 12.4555527,5.3107584 12.1828118,5.1484452 L7.58281181,2.4124452 C7.50536391,2.36511696 7.41393201,2.34245832 7.32406181,2.3483202 Z M7.81281181,3.6236952 L11.0543743,5.5545702 L7.81281181,7.4783088 L7.81281181,3.6236952 Z M3.44999931,11.9385816 C2.97949061,11.9385816 2.57870641,12.2214156 2.40062431,12.6225816 L1.37999931,12.6225816 C1.12594821,12.6225816 0.91999931,12.8267328 0.91999931,13.0785816 C0.91999931,13.3304304 1.12594821,13.5345816 1.37999931,13.5345816 L2.40062431,13.5345816 C2.57870641,13.9357476 2.97949061,14.2185816 3.44999931,14.2185816 C3.92050801,14.2185816 4.32129221,13.9357476 4.49937431,13.5345816 L17.0200005,13.5345816 C17.2740516,13.5345816 17.4800005,13.3304304 17.4800005,13.0785816 C17.4800005,12.8267328 17.2740516,12.6225816 17.0200005,12.6225816 L4.49937431,12.6225816 C4.32129221,12.2214156 3.92050801,11.9385816 3.44999931,11.9385816 Z",
  id: "Shape"
}))))))))));
function SvgStreamingVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingVideo);
export default __webpack_public_path__ + "static/media/streamingVideo.2b5491ecdb8dfe7a89eab07a62f05a54.svg";
export { ForwardRef as ReactComponent };